import { render, staticRenderFns } from "./Sequences.vue?vue&type=template&id=5532da34&scoped=true&"
import script from "./Sequences.vue?vue&type=script&lang=js&"
export * from "./Sequences.vue?vue&type=script&lang=js&"
import style0 from "./Sequences.vue?vue&type=style&index=0&id=5532da34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532da34",
  null
  
)

export default component.exports